<template lang="html">
  <transition
    v-if="modalOpen"
    name="modal"
  >
    <div class="registration-fence">
      <div class="registration-fence__content">
        <a
          class="registration-fence__close"
          @click="modalClose"
        >
          <svg-icon icon-name="close-light" />
        </a>
        <component
          :is="modalComponent"
          v-bind="modalProps"
          @close="modalClose"
        />
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

import SvgIcon from '@/components/svg_icon'

export default {
  name: 'Modal',
  components: { SvgIcon },
  computed: {
    ...mapState(['modalOpen', 'modalComponent', 'modalProps'])
  },
  methods: {
    ...mapMutations(['modalClose'])
  }
}
</script>

<style lang='scss' scoped>
  .registration-fence,
  .registration-fence__content {
    transition-duration: .3s;
  }

  .modal-enter,
  .modal-leave-to {
    opacity: 0;

    .registration-fence__content {
      transform: scale(1.1);
    }
  }
</style>
